import { render, staticRenderFns } from "./CareList.vue?vue&type=template&id=5ce0f69e&"
import script from "./CareList.vue?vue&type=script&lang=js&"
export * from "./CareList.vue?vue&type=script&lang=js&"
import style0 from "./CareList.vue?vue&type=style&index=0&id=5ce0f69e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports